import { useParams, Navigate } from 'react-router-dom';

// Old /category/<slug> links (from the earlier menswear menu) now go to the
// matching category listing. Same mapping as buildMeta() in
// Mithralaya-server/services/seo.js, which answers these with a 301.
const SUBCATEGORIES = ['Saree', 'Kurti', 'Churidar Set', 'Short Tops', 'T-Shirt', 'Bottoms', 'Nightwears', 'Boys', 'Girls', 'Baby'];
const DEPARTMENTS = { women: 'WOMEN', 'womens-wear': 'WOMEN', kids: 'KIDS', 'kids-wear': 'KIDS' };

const slugify = (v) => String(v || '').toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

const CategoryPage = () => {
  const slug = slugify(useParams().slug);
  const sub = SUBCATEGORIES.find((s) => [slugify(s), slugify(`${s}s`), slugify(`${s} clothing`)].includes(slug));
  const to = sub
    ? `/all-product?subCategory=${encodeURIComponent(sub)}`
    : DEPARTMENTS[slug]
      ? `/all-product?category=${DEPARTMENTS[slug]}`
      : '/all-product';
  return <Navigate to={to} replace />;
};

export default CategoryPage;
